class PriceField {
	constructor($field) {
		this.$field = $field;

		const { currency, currencyTarget } = this.$field.data();

		if(!currency && !currencyTarget) {
			console.warn("PriceField cannot be initialised without a currency or currency target.");
		}

		this.currency = currency;
		this.currencyTarget = currencyTarget;

		// Create display field
		const html = $field.prop("outerHTML");

		const $displayField = $(html);
		$displayField.attr("type", "text");
		$displayField.removeAttr("name");
		$displayField.attr("id", $field.attr("id") + "-price-display");
		$displayField.insertAfter($field);
		$field.hide();

		this.$displayField = $displayField;

		$displayField.on("focus", () => {
			$displayField.hide();
			$field.show().trigger("focus");
		});

		$field.on("blur", () => {
			this.updateDisplayPrice();
			$field.hide();
			$displayField.show();
		});

		$field.on("change input", () => this.updateDisplayPrice());

		this.updateDisplayPrice();
	}

	getCurrency() {
		if(this.currency) {
			return this.currency;
		}

		return $(this.currencyTarget).val();
	}

	updateDisplayPrice() {
		const formatter = new Intl.NumberFormat("en-GB", {
			style: "currency",
			currency: this.getCurrency()
		});

		const value = this.$field.val();

		if(value === "") {
			this.$displayField.val("");
		}
		else {
			this.$displayField.val(formatter.format(this.$field.val()));
		}

		this.$displayField.get(0).setCustomValidity(this.$field.get(0).validationMessage);
	}

	setRequired(required) {
		this.$displayField.prop("required", required);
		this.$field.prop("required", required);
	}


}
